import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AppService } from '@app-services/app.service';

@Injectable({
	providedIn: 'root'
})
export class AuthGuard implements CanActivate {
	user: any;

	constructor(
		private _appService: AppService,
		private _router: Router,
	) {
		this.getStoredUser();
	}

	getStoredUser() {
		this.user = localStorage.getItem('user');
	}

	canActivate(
		next: ActivatedRouteSnapshot,
		state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

		const blockAuthenticated = next.data.blockAuthenticated || false;

		this.getStoredUser();

		if (this.user) {
			if (blockAuthenticated) {
				this._router.navigate(['/pages/home/view']);
				return false;
			}
			return true;
		} else {
			if (!blockAuthenticated) {
				this._router.navigate(['/login']);
				return false;
			}
			return true;
		}
	}
}
